/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import './NoDataFound.scss';

export default function NoDataFound() {
  return (
    <div className="no-data-found">
      <Row>
        <Col className="col-2">
          <img
            src={require('../../img/no-data-found.svg')}
            alt="No Data Found"
          />
        </Col>
        <Col className="col-10 content">
          <h3>No results found!</h3>
          <p>
            We could not find any results matching this search. Try changing
            keyword or search filter
          </p>
        </Col>
      </Row>
    </div>
  );
}
